<h4 class="text-center">Enrolments By Date</h4>
<app-bar-chart-registration *ngIf="dataList.length>0" [dataList]="dataList"  ></app-bar-chart-registration>
<div class="table-responsive">

<table class="table table-striped">

    <tr><td>Date</td> <td>Count</td></tr>
<tr *ngFor="let dataData of dataList">
    <td> {{dataData['date']}}</td>
    <td> {{dataData['itemcount']}}</td>
</tr>

</table>
</div>
<div class="text-center">
    <hr/>
<a routerLink="/analytics/index" class="btn btn-primary"> 
    <i class="fa fa-line-chart"></i>  Analytics Home
</a>

</div>
